window.actualizarTableroSopladoPeriodo = null;

if (window.location.pathname === "/soplado/periodo") {

    const requestOptions = {
        method: "GET",
        credentials: "include", 
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };
    
    const conInfoBox = document.querySelector("#conInfoBox");
    var params = new URLSearchParams(window.location.search);
    var mes = params.get("mes");
    var año = params.get("año");
    
    function renderSkeletonTablero() {
        const infoBoxSkeleton = () => `
            <div class="infoBox contSkeleton">
                <h3>&nbsp;</h3>
                <p>&nbsp;</p>
            </div>`;

        conInfoBox.innerHTML = `
            <div class="contCant">
                <div class="contCantUnidades">
                    ${infoBoxSkeleton()}${infoBoxSkeleton()}${infoBoxSkeleton()}
                </div>
                <div class="contCantPeso">
                    ${infoBoxSkeleton()}${infoBoxSkeleton()}${infoBoxSkeleton()}
                </div>
            </div>
            <div class="contCantPorcentajes">
                ${infoBoxSkeleton()}${infoBoxSkeleton()}
            </div>
            <div class="contProductividad">
                ${infoBoxSkeleton()}${infoBoxSkeleton()}
            </div>`;
    }

    window.actualizarTableroSopladoPeriodo = (mes, año) => {

        const url = `/api/soplado/tableroPeriodo?mes=${mes}&año=${año}`;

        function formatearNumero(numero) {
            if (numero === null || numero === undefined || isNaN(numero)) return 0;
            return Number(numero).toLocaleString('en-US');
        }
        
        renderSkeletonTablero();

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {

                const data = result.result[0];

                let htmlTablero = `
                    <div class="contCant">
                        <div class="contCantUnidades">
                            <div class="infoBox">
                                <h3>🏭 Und. Producidas:</h3>
                                <p>${formatearNumero(data.undTotal)}</p>
                            </div>
                            <div class="infoBox">
                                <h3>✅ Und. Buenas:</h3>
                                <p>${formatearNumero(data.undBueno)}</p>
                            </div>
                            <div class="infoBox">
                                <h3>⚠️ Und. No conformes:</h3>
                                <p>${formatearNumero(data.undMalo)}</p>
                            </div>
                        </div>
                        <div class="contCantPeso">
                            <div class="infoBox">
                                <h3>⚖️ Peso Producido:</h3>
                                <p>${formatearNumero(data.pesoTotal)} t</p>
                            </div>
                            <div class="infoBox">
                                <h3>🟢 Peso Bueno:</h3>
                                <p>${formatearNumero(data.pesoBueno)} t</p>
                            </div>
                            <div class="infoBox">
                                <h3>🔴 Peso No conforme:</h3>
                                <p>${formatearNumero(data.pesoMalo)} kg</p>
                            </div>
                        </div>
                    </div>
                    <div class="contCantPorcentajes">
                        <div class="infoBox">
                            <h3>🏅 % 1A:</h3>
                            <p>${formatearNumero(data.porcBueno)}%</p>
                        </div>
                        <div class="infoBox">
                            <h3>🚫 % No conforme:</h3>
                            <p>${formatearNumero(data.porcMalo)}%</p>
                        </div>
                    </div>
                    <div class="contProductividad">
                        <div class="infoBox">
                            <h3>⏱️ Tiempo muerto:</h3>
                            <p>${formatearNumero(data.totalMinutosMuertos)}'</p>
                        </div>
                        <div class="infoBox">
                            <h3>📊 Prom. Und./h:</h3>
                            <p>${formatearNumero(data.promUndHora)}</p>
                        </div>
                    </div>
                    `;

                conInfoBox.innerHTML = htmlTablero;

            })
            .catch(err => {
                console.error("Error:", err);
                alert("Error crítico al procesar la solicitud, contactar al Administrador.");
            });
    };

    window.actualizarTableroSopladoPeriodo(mes, año);

    setInterval(() => {
        actualizarTableroSopladoPeriodo(mes, año);
    }, 120000);

};